<template>
  <div class="">
    <div class="col-lg-12 text-center">

      <b-button v-if="custom_button == undefined || custom_button == null" v-b-modal="'create-comment-'+commentable_id" pill
                class="comment-form text-center animation-shadow stand-up-animation">شما
        هم نظر خود را ثبت کنید
      </b-button>

      <slot v-else name="modal-button"/>


    </div>
    <b-modal :id="'create-comment-'+commentable_id" centered hide-header-close
             title="ثبت نظر" @ok="onSubmit" @cancel="resetCommentForm">

      <form @submit.stop.prevent="onSubmit">

        <form-group :validations="$v.commentForm.body">
          <div slot-scope="{ errors, invalid }">
            <vue-editor class="dir-rtl text-right text-dark" placeholder="نظر خود را بنویسید"
                        v-model="commentForm.body" :editorToolbar="customToolbar"/>
            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>

        <b-col cols="12" class="d-flex flex-column align-items-center justify-content-center p-3">
          <star-rating v-model="commentForm.rate" class="rate-s"></star-rating>
        </b-col>

      </form>


      <template #modal-footer="{ ok, cancel}">
        <b-row class="d-flex flex-row justify-content-around w-100">
          <b-button size="sm" class="mt-3 rounded text-dark" pill variant="success" @click="ok()">ثبت</b-button>
          <b-button size="sm" class="mt-3 rounded text-light" pill variant="danger" @click="cancel()">انصراف</b-button>
        </b-row>
      </template>

    </b-modal>
  </div>
</template>

<script>
import {required} from "vuelidate/lib/validators";
import StarRating from 'vue-star-rating'
import FormGroup from "@/plugin/components/validator/FormGroup";
import FormErrorsManager
  from "@/plugin/components/validator/FormErrorsManager";

export default {
  name: "CreateCommentModal1",
  components: { FormGroup, FormErrorsManager, StarRating},
  props: ['commentable_id', 'commentable_type','custom_button'],
  data() {
    return {
      commentForm: {
        body: '',
        rate: 1,
        commentable_type: this.commentable_type,
        commentable_id: ''
      },
      customToolbar: [
        ["bold", "italic", "underline"],
        [{list: "ordered"}, {list: "bullet"}],
        [
          {align: ""},
          {align: "center"},
          {align: "right"},
          {align: "justify"}
        ],
        [{color: []}]
      ]
    }
  },
  validations: {
    commentForm: {
      body: {required},
      rate: {required}
    },
  },
  methods: {
    setCommentableId() {
      this.commentForm.commentable_id = this.commentable_id
    },
    createComment() {
      if (this.commentForm.rate === 0) {
        this.commentForm.rate = 1
      }
      this.commentForm.commentable_id = this.commentable_id
      this.$store.dispatch("Comment/createComment", this.commentForm)
    },
    resetCommentForm() {
      this.commentForm = {
        body: '',
        rate: 1,
        commentable_type: this.commentable_type,
        commentable_id: ''
      }
    },
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit(bvModalEvent) {
      bvModalEvent.preventDefault()
      if (this.invalid()) {
        this.createComment()
        this.$nextTick(() => {
          this.$bvModal.hide(`create-comment-${this.commentable_id}`)
          this.resetCommentForm()
        })
      }
    },
  },
}
</script>

<style>
.vue-star-rating-rating-text {
  display: none;
}

.wrap-text > p, .wrap-text > h1 {
  word-break: break-word;
}
</style>

<style scoped>
.comment-form {
  position: fixed;
  bottom: 30px;
  transition: all .3s ease-in-out;
  background-color: var(--secondary) !important;
  border: none !important;
  margin: 0 -70px;
}

.comment-form:hover {
  background-color: var(--primary) !important;
  color: var(--dark) !important;
}

hr {
  border: 1px solid grey;
  width: 80%;
}

.rate-s {
  height: 40px !important;
  width: max-content !important;
}

</style>